module.exports = __webpack_public_path__ + "static/cardiopatia-complexidade-49fe9eb82fb1aaf842c6fed087c1b0f4.jpg";